import request from '@/utils/request'

/**
 * 更新店铺状态
 * @param {Object} data 包含storeId和state
 * @returns {Promise}
 */
export function updateStoreState(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeApi.updateStoreState',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}